<template>
  <!-- 开票金额 -->
  <div class="moneylist"
       style="background:#fff;margin-top:0.12rem;">
    <div class="btn-wrap">
      <div class="addbtn" v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
           @click="addBtn">
        <span>+</span>
        <span>添加金额</span>
      </div>
      <div class="addbtn" v-else>
        <span>+</span>
        <span>添加金额</span>
      </div>
    </div>
    <!-- 开票金额列表 -->
    <div>
      <ul class="all-list"
          v-for="(invoiceItem,invoiceIndex) in formData.money"
          :key="invoiceIndex">
        <li class="infoitems">
          <div class="item-left">
            <span class="requiretip">*</span>
            <span class="">开票金额</span>
          </div>
          <div class="item-right">
            <input type="text"
                   v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                   class="input-right"
                   v-model='formData.money[invoiceIndex]'
                   placeholder="请输入">
            <span v-else>{{formData.money[invoiceIndex]}}</span>
          </div>
        </li>
        <li class="infoitems">
          <div class="item-left"
               style="width:30%">
            <span class="requiretip">*</span>
            <span class="">税率</span>
          </div>
          <div class="item-right"
               v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
               style="width:90%"
               @click="selectTax(invoiceIndex)">
            <span v-if="formData.tax_type[invoiceIndex]">{{allTax[formData.tax_type[invoiceIndex]]}}</span>
            <span v-else>请选择</span>
          </div>
          <div class="item-right"
               v-else
               style="width:90%">
            <span>{{allTax[formData.tax_type[invoiceIndex]]}}</span>

          </div>
        </li>
        <li class="infoitems">
          <div class="item-left">
            <span class="requiretip">*</span>
            <span class="">预计回款时间</span>
          </div>
          <div class="item-right" v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
               @click="openTimeModal(invoiceIndex)">
            <span>{{formData.scheduled_at[invoiceIndex]}}</span>
          </div>
          <div class="item-right" v-else>
            <span>{{formData.scheduled_at[invoiceIndex]}}</span>
          </div>
        </li>
        <div @click="delBtn(invoiceIndex)" v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'" >
          <div class="icon_del"></div>
        </div>
         <div v-else>
          <div class="icon_del"></div>
        </div>

      </ul>
    </div>
    <!-- 开票金额列表 -->
    <!-- 底部弹窗，筛选数据begin -->
    <mt-popup v-model="PopupVisible"
              position="bottom"
              popup-transition="popup-fade"
              style="width:100%">
      <mt-picker :slots="taxList"
                 @change="onVisitChange"
                 valueKey="name"></mt-picker>
      <div class="footer">
        <span @click="cancelBtn">取消</span>
        <span @click="confirmBtn"
              class="confirm">确认</span>
      </div>
    </mt-popup>
    <!-- 底部弹窗，筛选数据begin -->
    <!-- 预计回款时间 -->
    <mt-datetime-picker class="picker_show"
                        ref="picker"
                        type="date"
                        :startDate="startDate"
                        :endDate="endDate"
                        @confirm="handleConfirm"
                        @cancel="handleCancel"></mt-datetime-picker>
    <!-- 预计回款时间 -->
  </div>
  <!-- 开票金额 -->
</template>
<script>


  import Vue from 'vue'
  import { Popup, Picker, MessageBox } from 'mint-ui';
  Vue.component(Picker.name, Picker);
  Vue.component(Popup.name, Popup);
  export default {
    props: {
      moneyFieldState: {
        type: Object,
        default: () => {
          return {}
        }
      },
      editMoneyData: {
        type: Array,
        default: () => {
          return []
        }
      },
      operationStatus: {//操作步骤
        type: String,
        default: () => {
          return '0'
        }
      },

    },
    watch: {

    },
    data () {
      return {
        startDate: new Date('2000-01-01'),      //设置开始时间
        endDate: new Date('2200-01-22'),   //设置结束时间
        reviewState: '',//当前数据的审核状态
        formData: {
          money: [null],//开票金额
          tax_type: [],//税率
          scheduled_at: [''],//预计回款时间
        },
        ruleValidate: {//验证
          money: {
            require: true,
            mesg: '金额不能为空'
          },
          tax_type: {
            require: true,
            mesg: '税率不能为空'
          },
          scheduled_at: {
            require: true,
            mesg: '预计回款时间不能为空'
          },

        },
        invoiceLength: 1,//开票金额的长度
        PopupVisible: false,
        tempTax: '',//临时的税率
        tempNum: '',//当前点击的第几个税率的下标
        tempTimeIndex: '',//临时当前的日期下标
        allTax: { 1: "【软件】思为软件三维远程展示系统（16%）", 2: "【其他电子设备】辅助设备（16%）", 3: "【信息技术服务】软件开发（6%）" ,4: "【软件】思为软件三维远程展示系统（13%）",5: "【其他电子设备】辅助设备（13%）",6: "思为通盘通客小程序软件V4.0.0（13%）",7: "思为全景云平台系统[简称：全景云平台]V1.0.0（13%）",8: "思为知屋SaaS系统[简称：知屋系统]V2.1.0（13%）",9: "思为知屋名片小程序软件 [简称：名片小程序]V1.0.0（13%）",10: "思为软件移动vr在线看房系统V1.0 （13%）"},
        taxList: [{
          flex: 1,
          values: [{ id: '1', name: '【软件】思为软件三维远程展示系统（16%）' }, { id: '2', name: '【其他电子设备】辅助设备（16%）' }, { id: '3', name: '【信息技术服务】软件开发（6%）' },{id:'4',name:'【软件】思为软件三维远程展示系统（13%）'},{id:'5',name:'【其他电子设备】辅助设备（13%）'},{id:'6',name:'思为通盘通客小程序软件V4.0.0（13%）'},{id:'7',name:'思为全景云平台系统[简称：全景云平台]V1.0.0（13%）'},{id:'8',name:'思为知屋SaaS系统[简称：知屋系统]V2.1.0（13%）'},{id:'9',name:'思为知屋名片小程序软件 [简称：名片小程序]V1.0.0（13%）'},{id:'10',name:'思为软件移动vr在线看房系统V1.0 （13%）'},],
          textAlign: 'center'
        }],
      }
    },

    methods: {
      addBtn () {//添加金额
        this.formData.money.push('')
        this.formData.tax_type.push('')
        this.formData.scheduled_at.push(null)


      },
      delBtn (index) {//减少
        this.tempTimeIndex--
        this.formData.money.splice(index, 1)
        this.formData.tax_type.splice(index, 1)
        this.formData.scheduled_at.splice(index, 1)
      },
      selectTax (index) {//  点击选择税率
        this.PopupVisible = true
        this.tempNum = index//当前点击的下表
      },
      onVisitChange (event) {//
        this.tempTax = event.values['0'].id//名字
      },

      cancelBtn () {
        this.PopupVisible = false
      },
      confirmBtn () {
        this.PopupVisible = false
        this.formData.tax_type[this.tempNum] = this.tempTax
      },
      parseTime (time) {
        time = time == null ? '' : time
        if (typeof time == 'object') {
          var d = new Date(time)
          let parseTime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
          return parseTime
        } else {
          return time
        }
      },
      openTimeModal (index) {//预计回款时间
        this.tempTimeIndex = index
        this.$refs.picker.open()
      },
      handleConfirm (val) {
        this.formData.scheduled_at[this.tempTimeIndex] = this.parseTime(val)
        this.invoiceLength = this.formData.money.length;
        this.formData.scheduled_at = this.formData.scheduled_at.slice(0, this.invoiceLength)
      },
      handleCancel () {

      },
      // 验证当前form带requiretip 类名的字段
      checkField () {
        let fieldState = true
        let keyArr = Object.keys(this.ruleValidate)
        console.log('keyArr',keyArr)
        for (let i = 0; i < keyArr.length; i++) {
          if (this.ruleValidate[keyArr[i]].require && this.formData[keyArr[i]] == '') {
            MessageBox('提示', this.ruleValidate[keyArr[i]].mesg)
            fieldState = false
            break
          }
        }
        // 如果验证通过则返回当前组件的forData
        if (fieldState) {
          return this.formData
        }
      }
    },
    created () {
      this.reviewState =window.localStorage.getItem('reviewState')
      if (this.moneyFieldState && this.moneyFieldState.money && this.moneyFieldState.tax_type && this.moneyFieldState.scheduled_at) {//保存并下一步
        this.formData = this.moneyFieldState
      }
      if (this.operationStatus == '1' && this.editMoneyData) {//编辑得到数据
        this.formData.money = this.editMoneyData.map(item => {
          return item.money
        })
        this.formData.tax_type = this.editMoneyData.map(item => {
          return item.tax_type
        })
        this.formData.scheduled_at = this.editMoneyData.map(item => {
          return item.scheduled_at.slice(0, 10)
        })

      } else {

      }
    }
  }
</script>
<style scoped>
  .picker_show /deep/ .mint-datetime-action {
    z-index: 10000;
    position: relative;
  }
  .picker_show /deep/ .picker-toolbar {
    z-index: 8000;
    position: fixed;
    width: 100%;
    margin-bottom: 40px;
    background: #fff;
  }
  .picker_show /deep/ .picker-items {
    margin-top: 30px;
  }
  .moneylist {
    font-size: 0.4rem;
    padding-bottom: 1.4rem;
    overflow: hidden;
  }
  .btn-wrap {
    margin: 0.5rem;
  }
  .addbtn {
    border: 1px solid #5483d2;
    width: 2.5rem;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    color: #5483d2;
    border-radius: 0.4rem;
  }
  .all-list {
    position: relative;
    margin: 0.2rem 0.9rem 0 0.1rem;
    border: 1px solid #f0f0f0;
    border-bottom: none;
    border-radius: 4px;
  }
  .all-list-item {
    background: #fff;
  }
  .infoitems {
    height: 1.25rem;
    line-height: 1.25rem;
    display: flex;
    position: relative;
    padding: 0 0.1rem;
  }
  .infoitems:after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 1px;
    background: #d8d8d8;
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  .requiretip {
    color: #fb2e45;
  }
  .item-left {
    width: 36%;
    text-align: left;
  }
  .item-right {
    width: 64%;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .input-right {
    width: 100%;
    text-align: right;
  }
  .icon_del {
    width: 20px;
    height: 20px;
    background: url("../../assets/img/减号.png") no-repeat;
    background-size: cover;
    position: absolute;
    right: -0.8rem;
    top: 1.5rem;
  }
  .footer {
    width: 100%;
    height: 1.25rem;
    font-size: 0;
  }
  .footer span {
    width: 50%;
    height: 1.125rem;
    font-size: 0.5rem;
    line-height: 1.25rem;
    display: inline-block;
    text-align: center;
  }
  .confirm {
    color: #5483d2;
  }
</style>


// WEBPACK FOOTER //
// src/components/Ticket/TicketMoney.vue